<template>
  <div>
    <div id="editCollectionModal" class="modal modal-fixed-footer">
      <div class="modal-content">
        <h4>{{ title }}</h4>
        <code>id: {{ collectionData.id }}</code>
        <div class="row">
          <div class="input-field col s2">
            <input v-model="searchText" id="first_name" type="text" />
            <label for="first_name">id produktu</label>
          </div>
          <div class="input-field col s9" v-if="currentItem">
            {{ currentItem?.id }}
            {{ currentItem?.name }}
            <img
              v-if="currentItem?.imgsBySize && currentItem?.imgsBySize['150']"
              v-bind:src="`${env.VUE_APP_API}/ii/${
                currentItem?.id
              }/150/${currentItem.imgsBySize['150'].slice(0, 1)}`"
              style="float: right"
              alt="obrazek"
            />
            <a
              v-if="currentItem"
              v-bind:href="`${env.VUE_APP_UI}${'/i_' + currentItem?.prettyId}`"
              target="_new"
            >
              <i class="material-icons">launch</i>
            </a>
            <br /><br /><a
              @click="addToClipboard(currentItem)"
              class="waves-effect waves-light btn-small"
              ><i class="material-icons left">library_add</i>dodaj do
              kolekcji</a
            >
          </div>
        </div>

        <div class="row">
          <div class="col s12">
            <ul class="collection">
              <li
                v-for="(item, index) in clipboard"
                :key="item.id"
                class="collection-item"
              >
                <span class="admin-itemId">{{ item.id }}</span>
                {{ item.name }}
                <a
                  href
                  class="secondary-content"
                  @click.prevent="removeFromClipboard(item.id)"
                  ><i class="material-icons">delete</i></a
                >

                <a
                  href
                  v-if="index > 0"
                  class="secondary-content"
                  @click.prevent="moveTo(index, index - 1)"
                  ><i class="material-icons">keyboard_arrow_up</i></a
                >
                <i
                  class="secondary-content"
                  v-if="index === 0"
                  style="width: 24px; height: 2px"
                >
                </i>

                <a
                  href
                  v-if="index < clipboard?.length - 1"
                  class="secondary-content"
                  @click.prevent="moveTo(index, index + 1)"
                  ><i class="material-icons">keyboard_arrow_down</i></a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <a class="waves-effect waves-teal btn" @click="accept()"
          ><i class="material-icons left">save</i>Zapisz</a
        >

        <a
          class="waves-effect waves-teal btn-flat"
          @click="
            modal.close();
            reject();
          "
          >Anuluj</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    collection: Object,
    onAcceptCallback: Function,
    onRejectCallback: Function,
    initialItems: Array,
    config: Object,
  },

  data() {
    return {
      searchText: "",
      currentItem: null,
      clipboard: [],
      env: process.env,
      title: "",
      collectionData: {},
      titleEdit: false,

      modal: null,
    };
  },

  methods: {
    addToClipboard(item) {
      this.clipboard.push({ id: item.id, name: item.name });
      this.currentItem = null; // Reset currentItem after adding to clipboard
      this.searchText = null;
    },
    removeFromClipboard(itemId) {
      this.clipboard = this.clipboard.filter((item) => item.id !== itemId);
    },

    moveTo(from, to) {
      console.debug("moveTo", from, to);
      const [item] = this.clipboard.splice(from, 1); // Remove item from index `from`
      this.clipboard.splice(to, 0, item); // Insert i
    },

    openModal: function (params) {
      console.debug("calling openModal", params, params.title);
      this.clipboard =
        params.collection.items?.map((item) => {
          return { id: item.id, name: item.name };
        }) || [];

      this.title = params.title || "Edycja kolekcji";
      this.collectionData = params.collection || {};
      this.modal.open();
    },

    closeModal: function () {
      console.debug("calling closeModal");
      this.modal.close();
    },

    accept() {
      console.debug("accept...");
      this.onAcceptCallback({
        collectionData: this.collectionData,
        items: this.clipboard,
      });
    },

    reject() {
      console.debug("reject called");
    },
  },

  watch: {
    searchText: function (after, before) {
      console.log("searchText changed", after, before);
      // You can add logic here to handle the change in searchText
      this.currentItem = null; // Reset currentItem when searchText changes
      axios
        .get(process.env.VUE_APP_API + "/ui/item.json", {
          params: {
            id: after,
            ref: "admin:collectionBuilder:searchText",
          },
        })
        .then((axiosResponse) => {
          this.currentItem = axiosResponse.data.item;
          console.debug("axiosResponse ok ");
        })
        .catch((error) => {
          if (error?.response?.status === 404) {
          } else {
            console.error("admin:collectionBuilder:searchText", error);
          }
        });
    },
  },

  created() {
    console.debug("CollectionBuilder created");
  },

  mounted() {
    console.debug("CollectionBuilder mounted");
    M.Modal.init(document.querySelectorAll("#editCollectionModal"), {
      onCloseEnd: () => {
        console.log("modal on close end");
      },
    });
    this.modal = M.Modal.getInstance(
      document.querySelector("#editCollectionModal"),
    );
  },

  beforeDestroy() {
    console.debug("CollectionBuilder beforeDestroy");
  },

  destroyed() {
    this.modal.destroy();
    console.debug("CollectionBuilder destroyed");
  },
};
</script>

<style scoped></style>
